import script from "./FamilyGroupMemberRemoveModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupMemberRemoveModal.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupMemberRemoveModal.vue?vue&type=style&index=0&id=20d79537&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d79537"]])

export default __exports__